@if (state.topic; as topic) {
  <div
    class="z-3 mb-4 flex min-h-[60px] flex-shrink-0 items-center justify-between border-b border-neutral-200 bg-neutral-50 px-4 py-2 text-lg font-semibold"
  >
    <span>{{ topic.code }} <dojo-localized-string [content]="topic.name" /></span>
  </div>
}

<div class="custom-mat-tab size-l">
  <nav mat-tab-nav-bar [tabPanel]="tabPanel">
    @for (tab of tabs; track tab) {
      <a mat-tab-link [routerLink]="tab" routerLinkActive #rla="routerLinkActive" [active]="rla.isActive">
        {{ 'examdojo.learn_hub.topic_tabs.' + tab | transloco }}
      </a>
    }
  </nav>

  <mat-tab-nav-panel #tabPanel>
    <div class="p-4">
      <router-outlet></router-outlet>
    </div>
  </mat-tab-nav-panel>
</div>
